<template>
    <div>
        <div class="alert alert-secondary">
            <div class="alert-text"> {{$t('REGISTRATION.companyAddress')}} </div>
        </div>
        <form-input :placeholder="$t('COMPANYDATA.street')"
                    :elementID="'addressStreet'"
                    :containerClass="'form-group'"
                    :validator="validator.street"
                    :inputClass="'form-control-sm'"
                    :inputType="'text'"
                    :required="isRequired('street')"
                    v-model="address.street">
        </form-input>

        <form-input :placeholder="$t('COMPANYDATA.streetNumber')"
                    :elementID="'addressStreetNumber'"
                    :containerClass="'form-group'"
                    :validator="validator.houseNumber"
                    :inputClass="'form-control-sm'"
                    :inputType="'text'"
                    :required="isRequired('houseNumber')"
                    v-model="address.houseNumber">
        </form-input>


        <form-input :placeholder="$t('COMPANYDATA.postCode')"
                    :elementID="'addressPostCode'"
                    :containerClass="'form-group'"
                    :validator="validator.postcode"
                    :inputClass="'form-control-sm'"
                    :inputType="'text'"
                    :required="isRequired('postcode')"
                    v-model="address.postcode">
        </form-input>


        <form-input :placeholder="$t('COMPANYDATA.city')"
                    :elementID="'addressCity'"
                    :containerClass="'form-group'"
                    :validator="validator.city"
                    :inputClass="'form-control-sm'"
                    :inputType="'text'"
                    :required="isRequired('city')"
                    v-model="address.city">
        </form-input>



        <form-input :placeholder="$t('COMPANYDATA.country')"
                    :elementID="'country'"
                    :containerClass="'form-group'"
                    :validator="validator.country"
                    :inputClass="'form-control-sm'"
                    :inputType="'text'"
                    :required="isRequired('country')"
                    v-model="address.country">
        </form-input>


        <form-input :placeholder="$t('COMPANYDATA.latitude')"
                    :elementID="'latitude'"
                    :containerClass="'form-group'"
                    :validator="validator.latitude"
                    :inputClass="'form-control-sm'"
                    :inputType="'number'"
                    :required="isRequired('latitude')"
                    :min="-90"
                    :max="90"
                    v-model="address.latitude">
        </form-input>

        <form-input :placeholder="$t('COMPANYDATA.longitude')"
                    :elementID="'longtitute'"
                    :containerClass="'form-group'"
                    :validator="validator.longitude"
                    :inputClass="'form-control-sm'"
                    :inputType="'number'"
                    :required="isRequired('longitude')"
                    :min="-180"
                    :max="180"
                    v-model="address.longitude">
        </form-input>
        <form-input :placeholder="$t('COMPANYDATA.zone')"
                    :elementID="'zone'"
                    :containerClass="'form-group'"
                    :validator="validator.zone"
                    :inputClass="'form-control-sm'"
                    :inputType="'text'"
                    :required="isRequired('zone')"
                    v-model="address.zone">
        </form-input>
    </div>
</template>
<script>
import FormInput from '../../../../Shared/UI/Form/FormInput.vue';

export default {
    name: 'ShopAddressData',
    components: {FormInput},
    props: {
      data: {
        type: Object,
        default(){
          return {};
        }
      },
      validator: {
        type: Object,
        default: () => {},
      }
    },
    computed: {
      address:{
        get() {
            return this.data;
        },
        set(newValue){
            this.$emit('update:data', newValue);
        }
      }
    },
    methods: {
      isRequired(inputType) {
            return this.validator[inputType] ? this.validator[inputType].$params.hasOwnProperty('required') : false;
        }
    },
    beforeMount(){
        this.address = this.data;
    }
};
</script>
